import React from 'react';

const Footer = () => {
  return (
  <footer className="bg-white dark:bg-gray-950 py-5 border-t border-gray-100 dark:border-gray-900">
      <div className="max-w-4xl mx-auto px-6 flex flex-col items-center text-center">
    <div className="text-sm text-gray-500 dark:text-gray-400 mb-3">
          © {new Date().getFullYear()} Finalism
        </div>
        
    <div className="text-sm text-gray-500 dark:text-gray-400 mb-2">
          Built by <span className='font-bold text-primary'>Yazeed</span> during peak procrastination hours
        </div>
        
        <a 
          href="https://t.me/bodyelectric" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-primary hover:text-primary-hover transition-colors"
          aria-label="Contact on Telegram"
        >
          <svg 
            className="w-5 h-5" 
            viewBox="0 0 24 24" 
            fill="currentColor"
          >
            <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
          </svg>
        </a>
      </div>
    </footer>
  );
};

export default Footer;